import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { IBasketLine } from "../../../models/catalogue";
import { usePageSetting } from "../../../utils/settings";
import { BasketLineImage } from "./BasketLineImage";
import { BasketLineOptions } from "./BasketLineOptions";
import { BasketLineQuantity } from "./BasketLineQuantity";
import { BasketLineTitle } from "./BasketLineTitle";

export const BasketLineMinimal = (
    props: Immutable<{
        line: IBasketLine;
        isBundled?: boolean;
    }>,
): React.ReactNode => {
    const bundleCalloutText =
        usePageSetting("bundle_callout_text") ||
        t`This item is part of a bundle`;
    return (
        <li>
            <div
                className="basket-line basket-line--minimal"
                role="group"
                // TODO(i18n): Translate aria-label for accessibility: aria-label={t`product`}
                aria-label="product"
            >
                <div className="basket-line__graphic">
                    <BasketLineImage product={props.line.product} />
                </div>
                <div className="basket-line__details">
                    <div className="basket-line__details__row">
                        <BasketLineTitle product={props.line.product} />
                        <BasketLineQuantity quantity={props.line.quantity} />
                    </div>
                    <div className="basket-line__details__row">
                        <BasketLineOptions product={props.line.product} />
                    </div>
                    {props.isBundled && (
                        <div className="basket-line__details__row">
                            <span className="basket-line__bundle-callout">
                                {bundleCalloutText}
                            </span>
                        </div>
                    )}
                </div>
            </div>
        </li>
    );
};
